import { connect } from "react-redux";
import { RootState } from "store";
import { PageLoaderType } from "./types";
import { GlobalLoader } from "@pickit/pickit-components";
import { sessionSelector } from "reducers/session";

export const PageLoader = (props: PageLoaderType) => {
  return <GlobalLoader isLoading={props.isFetching} />;
};

const mapStateToProps = (state: RootState) => ({
  isFetching: sessionSelector(state).fetching,
});

export default connect(mapStateToProps)(PageLoader);
